import React, { useState } from "react";
import { useForm } from "react-hook-form";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { Flip, ToastContainer, toast } from "react-toastify";
import { ArrowRight } from "lucide-react";
import useAuth from "../../../hooks/useAuth";
import ButtonLoading from "../../../components/ButtonLoading";

const Withdraw = () => {
  const { authenticated } = useAuth();
  const [disabled, setDisabled] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  const { register, handleSubmit } = useForm();
  return (
    <div className="container bg-black p-4 rounded-xl bg-opacity-50 mx-auto ">
      <ToastContainer />
      <div className="text-lg uppercase font-bold">Withdraw</div>
      <small>Withdraw funds From your account.</small>

      <div>
        <div className="text-lg uppercase font-bold">
          Balance : {authenticated?.user?.balance} PKR
        </div>
        <small>Balance of funds in your account.</small>
      </div>
      <div>
        <div className="text-lg uppercase font-bold">Important Note </div>
        <small>
          Balance will be updated within 15-30 minutes, depending on the
          traffic.
        </small>
      </div>
      <div id="easypaisa" className="mt-4">
        <div className="md:flex justify-between items-center">
          <form
            className="md:w-1/2 w-full mt-5"
            id="WithdrawForm"
            onSubmit={handleSubmit(async (data) => {
              setDisabled(true);
              console.log(data);
              const dataSubmit = {
                easypaisaName: data.easypaisaName,
                easypaisaNumber: data.easypaisaNumber,
                easypaisaAmount: data.easypaisaAmount,
              };

              await axiosPrivate
                .post("/easypaisa/WithdrawRequest", dataSubmit, {
                  withCredentials: true,
                })
                .then((res) => {
                  console.log(res?.data);
                  toast.success(
                    "Your Withdraw Request has been generated successfully! 👌",
                    {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                      transition: Flip,
                    }
                  );
                  //   setFiles([]);

                  setDisabled(false);
                  document.getElementById("WithdrawForm").reset();
                })
                .catch((err) => {
                  console.log(err);
                  toast.error("Something went wrong!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                  });
                  setDisabled(false);
                  document.getElementById("WithdrawForm").reset();
                });
            })}
          >
            <div>
              <div>
                <label>To Name : </label>
                <small>Name Should be exact on Easypaisa.</small>
              </div>
              <input
                {...register("easypaisaName", {
                  required: "This field is required.",
                })}
                className="w-full my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                type="text"
                placeholder="EASYPAISA Name"
              />
            </div>
            <div>
              <div>
                <label>To Number : </label>
                <small>Name Should be exact on Easypaisa.</small>
              </div>
              <input
                {...register("easypaisaNumber", {
                  required: "This field is required.",
                })}
                className="w-full my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                type="text"
                placeholder="EASYPAISA Number"
              />
            </div>
            <div>
              <div>
                <label>Amount (PKR) : </label>
                <small>
                  Enter amount to be withdrawn from Easypaisa.(minimum 100 PKR)
                </small>
              </div>
              <input
                {...register("easypaisaAmount", {
                  required: "This field is required.",
                })}
                className="w-full my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                type="text"
                placeholder="withdrawal amount"
              />
            </div>
            <div>
              <div className="container flex justify-center items-center mt-4">
                <span>
                  <button
                    disabled={disabled}
                    className=" tracking-wide mt-3 font-semibold bg-purple-700 text-white w-full py-3 px-10 rounded-lg hover:bg-purple-900 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                  >
                    {disabled ? (
                      <ButtonLoading />
                    ) : (
                      <>
                        <p> Submit</p> <ArrowRight />
                      </>
                    )}
                  </button>
                </span>
              </div>
            </div>
          </form>

          <img
            src="https://crystalpng.com/wp-content/uploads/2024/10/Easypaisa-logo.png"
            className="w-80 h-80 mt-4 mx-4 rounded"
            alt="easypaisa logo "
          />
        </div>
      </div>
    </div>
  );
};

export default Withdraw;
